import "../styles/Production.css";

export default function Production() {
  return (
    <section className="production-section">

      <div className="container">

        {/* HEADER */}
        <div className="production-header">

          <h2>Production Strength</h2>

          <p>
            Delivering excellence through advanced infrastructure,
            skilled workforce, and high-capacity manufacturing systems.
          </p>

        </div>

        {/* ROW */}
        <div className="production-row">

          {/* ITEM 1 */}
          <div className="production-card">

            <div className="production-icon">👨‍🏭</div>

            <h3>100+ Workforce</h3>

            <p>Skilled technical team</p>

          </div>

          {/* ITEM 2 */}
          <div className="production-card">

            <div className="production-icon">🏭</div>

            <h3>1000+ Units/Month</h3>

            <p>High capacity assembly</p>

          </div>

          {/* ITEM 3 */}
          <div className="production-card">

            <div className="production-icon">✅</div>

            <h3>Certified Quality</h3>

            <p>Standardized SOP processes</p>

          </div>

          {/* ITEM 4 */}
          <div className="production-card">

            <div className="production-icon">⚙</div>

            <h3>Modern Setup</h3>

            <p>Advanced manufacturing lines</p>

          </div>

          {/* ITEM 5 */}
          <div className="production-card">

            <div className="production-icon">🌍</div>

            <h3>OEM Expertise</h3>

            <p>Partner for global brands</p>

          </div>

        </div>

      </div>

    </section>
  );
}